<template>
  <div class="default-textarea" :class="{ focus: focus, disabled: disabled }">
    <div class="textarea-wrapper">
      <span class="label m-subhead-m" :class="{ errorLabel: error }">{{ label }}</span>
      <textarea class="m-body-m"
                v-on:input="$emit('input', $event.target.value), textareaScrollHeight($event.target)"
                v-on:blur="$emit('blur')"
                :value="value"
                :placeholder="placeholder"
                type="text"
                :rows="rows"
                ref="input"
                @focus="focus = true" @blur="focus = false"
                autocomplete="nope"
                :disabled="disabled">
      </textarea>
    </div>

    <div v-if="src" class="icon">
      <img :src="require(`@/assets/icons/${src}`)" alt="icon">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    label: String,
    src: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    rows: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      focus: false
    }
  },
  methods: {
    textareaScrollHeight (element) {
      if (element.value.length) {
        element.rows = 1
      } else {
        element.rows = this.rows
      }
      element.style.height = 'auto'
      element.style.height = `${element.scrollHeight}px`
    }
  },
  mounted () {
    const element = this.$refs.input
    if (element.value.length) {
      element.rows = 1
    }
    element.style.height = 'auto'
    element.style.height = `${element.scrollHeight}px`
  }
}
</script>

<style lang="less" scoped>
.default-textarea {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  min-height: 56px;
  border: 1px solid var(--grey-220);
  box-sizing: border-box;
  border-radius: var(--default-br);
  font-family: 'Montserrat';

  .icon {
    width: 16px;
    height: 16px;
    padding: 0 12px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .textarea-wrapper {
    width: 100%;
  }

  textarea {
    display: flex;
    align-items: center;
    padding: 0;
    width: 100%;
    border: none;
    -webkit-appearance: none;
    resize: none;
    overflow: hidden;
    &.auto {
      overflow-y: hidden;
    }

    &::placeholder {
      color: var(--grey-180);
    }

    &:focus {
      border: none;
      outline: none;
    }
  }

  .label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 20px;
    color: var(--grey-140);
  }

  &:hover {
    .label {
      color: var(--black);
    }
  }

  .label.errorLabel {
    color: var(--red);
  }
}

.default-textarea.focus {
  border: 1px solid var(--second-base);
}

.default-textarea.disabled {
  background: var(--grey-240);
  cursor: not-allowed;
  filter: grayscale(100%);

  .label {
    color: var(--grey-200);
  }

  &:hover {
    .label {
      color: var(--grey-200);
    }
  }

  textarea {
    color: var(--grey-200);
    cursor: not-allowed;
    background: none;
  }
}
</style>
